




import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component
export default class RedirectView extends Vue {
  @Action
  setErrorModal!: () => void;

  created() {
    const url = this.$route.query.url;
    switch (url) {
      case 'deactivate':
        this.$router.replace({
          path: '/faq/article/360040686192'
        });
        break;
      case 'withdraw-limit':
        this.$router.replace({
          path: '/faq/article/360041232811'
        });
        break;
      default:
        if (sessionStorage.getItem('uuid')) {
          this.$router.replace({
            path: '/faq'
          });
        } else {
          this.setErrorModal();
          return;
        }
    }
  }
}
